import { tickerItems } from '@/mocks/homeNews';

export default function TopUpdateBar() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="w-full bg-foreground-950 text-background-50">
      <div className="flex items-stretch">
        <div className="flex items-center gap-2 bg-primary-600 px-3 md:px-5 py-2 shrink-0">
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-broadcast-line text-[14px] text-background-50" />
          </span>
          <span className="text-[12px] md:text-[13px] font-semibold tracking-wide whitespace-nowrap">
            实时更新条
          </span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
            {loop.map((item, idx) => (
              <div
                key={`${item.time}-${idx}`}
                className="flex items-center gap-2 px-5 py-2 whitespace-nowrap"
              >
                <span className="text-[12px] font-semibold text-accent-400">{item.time}</span>
                <span className="text-[12px] md:text-[13px] text-background-200">{item.text}</span>
                <span className="w-1 h-1 rounded-full bg-primary-500 ml-3" />
              </div>
            ))}
          </div>
        </div>
        <div className="hidden md:flex items-center gap-2 px-5 text-[12px] text-background-300 shrink-0">
          <span className="w-1.5 h-1.5 rounded-full bg-primary-500" />
          正在追踪 8 起事件
        </div>
      </div>
    </div>
  );
}